import { TimestampsInterface, uid } from '@/types/models'

export default class Timestampable {
  createdBy?: uid
  // createdAt: firestoreTimestamp | undefined // Date | firebase.firestore.FieldValue;
  createdAt?: Date | null
  updatedBy?: uid
  // updatedAt: firestoreTimestamp | undefined = undefined; // Date | firebase.firestore.FieldValue | undefined = undefined;
  updatedAt?: Date | null

  constructor({
    createdAt,
    createdBy,
    updatedAt,
    updatedBy,
  }: TimestampsInterface) {
    this.createdAt = createdAt
    this.createdBy = createdBy
    this.updatedAt = updatedAt
    this.updatedBy = updatedBy
  }
}
